import { getDurationInUserFriendlyFormat } from 'flow/utils';
import {
    getCallRecordAnsweredByAgentNameAbbreviated,
    getCallRecordInCallDuration,
    getCallRecordInQueueDuration,
} from 'flow/utils/call-records-utils';
import { twMerge } from 'tailwind-merge';
import { translateTime } from 'flow/utils/browser-utils';
import { CallRecord } from 'flow/types/CallRecord';
import { TypedMap } from 'flow/types/TypedMap';
import Icon from 'flow/components/ui-components/Icon';

interface Props {
    callRecord: TypedMap<CallRecord>;
    contextMenuIsActive: boolean;
    hideInQueueDuration?: boolean;
}

const PbxCallRecordDetailItems = ({
    callRecord,
    contextMenuIsActive,
    hideInQueueDuration = false,
}: Props) => (
    <div className="flex shrink-0 items-center gap-x-2">
        {!!getDurationInUserFriendlyFormat(
            getCallRecordInQueueDuration(callRecord),
        ) &&
            !hideInQueueDuration && (
                <div
                    className={twMerge(
                        'flex gap-x-2 rounded-sm p-2 text-xs',
                        contextMenuIsActive
                            ? 'bg-gray-200'
                            : 'bg-gray-100 group-hover:bg-gray-200',
                    )}
                >
                    <Icon iconKey="timer" size={'1rem'} />
                    {translateTime(
                        getDurationInUserFriendlyFormat(
                            getCallRecordInQueueDuration(callRecord),
                        ),
                    )}
                </div>
            )}

        {!!getDurationInUserFriendlyFormat(
            getCallRecordInCallDuration(callRecord),
        ) && (
            <div
                className={twMerge(
                    'flex gap-x-1 rounded-sm p-2 text-xs',
                    contextMenuIsActive
                        ? 'bg-gray-200'
                        : 'bg-gray-100 group-hover:bg-gray-200',
                )}
            >
                <Icon iconKey="phone_in_talk" size={'1rem'} />
                {translateTime(
                    getDurationInUserFriendlyFormat(
                        getCallRecordInCallDuration(callRecord),
                    ),
                )}
            </div>
        )}

        {!!getCallRecordAnsweredByAgentNameAbbreviated(callRecord) && (
            <div
                className={twMerge(
                    'flex gap-x-1 rounded-sm p-2 text-xs',
                    contextMenuIsActive
                        ? 'bg-gray-200'
                        : 'bg-gray-100 group-hover:bg-gray-200',
                )}
            >
                <Icon iconKey="headset" size={'1rem'} />
                {getCallRecordAnsweredByAgentNameAbbreviated(callRecord)}
            </div>
        )}
    </div>
);

export default PbxCallRecordDetailItems;
